import { Svg } from "assets";
import {PermissionsList, RolePermission} from "../utils";

export const RoutersInfo = () => {
  return [
    RolePermission([PermissionsList.ALL_ACCESS.code]) &&  {
      name: "Users",
      path: "/users",
      Icon: Svg.UsersMenuSvg,
    },

    {
      name: "Employee",
      path: "/employees",
      Icon: Svg.EmployeeMenu,
    },

    {
      name: "Facilities",
      path: "/facilities",
      Icon: Svg.FacilitiesMenu,
    },

    {
      name: "Payers",
      path: "/payers",
      Icon: Svg.PayerMenu,
    },

    {
      name: "Patients",
      path: "/patients",
      Icon: Svg.PatientsMenu,
    },

    {
      name: "Dispatch Board",
      path: "/dispatch-board",
      Icon: Svg.DispatchBoardMenu,
    },

    {
      name: "Pending Trips",
      path: "/pending-trips",
      Icon: Svg.PendingTripsMenu,
    },

    {
      name: "Vehicles",
      path: "/vehicles",
      Icon: Svg.VehiclesMenu,
    },

    // {
    //   name: "System",
    //   path: "/system",
    //   Icon: Svg.SystemMenu,
    // },
  ];
};
